import React, { lazy, Suspense, useEffect } from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import { withCookies } from 'react-cookie';
import { actLogout } from 'actions/loginStateActions';
import LoadingScreen from 'icw-components/LoadingScreen';
import routes from 'routes/beforeLogin';
import { isLoginExpired } from 'store/selectors/loginState';
import { LinkedInPopUp } from 'react-linkedin-login-oauth2';
import { getLocale } from 'util/icwUtility';
import { LINKEDIN_REDIRECT_PATH } from 'shared/constants';
import Example from 'components/New/Example';
import { StaticDataProvider } from 'context';
import { ConfigProvider } from 'antd';
import en from 'antd/es/locale/en_US';
import zhHk from 'antd/es/locale/zh_HK';
import zhCn from 'antd/es/locale/zh_CN';
import 'assets/css/flag-icons.css';
import './App.scss';
import SupplierInvitationTracking from 'modules/supplier/context/SupplierInvitationTracking';
import configureI18n from 'helpers/i18n';
import ScrollRestoration from 'components/New/ScrollRestoration/index';
const AuthApp = lazy(() => import('views/Layout/AuthApp'));

configureI18n(getLocale());

const antdLocale = {
  en: en,
  'zh-hk': zhHk,
  'zh-cn': zhCn,
};

export const App = ({ isUserExpired, onLogout }) => {
  let location = useLocation();
  useEffect(() => {
    if (isUserExpired) onLogout();
    if (typeof window.Chatra !== 'undefined') {
      let regex = /(en|zh-hk|zh-cn)\/(login|registration|reset-password)/;

      if (regex.test(location.pathname)) {
        window.Chatra('hide');
      } else {
        window.Chatra('show');
      }
    }
    // eslint-disable-next-line
  });
  const linkedinPopupPath = `/${getLocale()}/${LINKEDIN_REDIRECT_PATH}`;

  return (
    <>
      <ConfigProvider locale={antdLocale[getLocale()] || en}>
        <StaticDataProvider>
          <SupplierInvitationTracking>
            <ScrollRestoration></ScrollRestoration>
            <Route
              path="/"
              render={({ location }) => {
                window.gtag('config', 'UA-58450524-4', {
                  page_path: location.pathname + location.search,
                });
              }}
            />
            <Switch>
              {routes.map(({ path, component }) => (
                <Route key={path} path={path} component={component} />
              ))}
              <Route path={'/example'} component={Example} />

              <Route exact path={linkedinPopupPath} component={LinkedInPopUp} />
              <Suspense fallback={<LoadingScreen />}>
                <AuthApp />
              </Suspense>
            </Switch>
          </SupplierInvitationTracking>
        </StaticDataProvider>
      </ConfigProvider>
    </>
  );
};

const mapStateToProps = (state) => ({
  isUserExpired: isLoginExpired(state),
});

const mapDispatchToProps = (dispatch, { cookies }) => ({
  onLogout: () => dispatch(actLogout(cookies)),
});
export default withCookies(connect(mapStateToProps, mapDispatchToProps)(App));
